<template>
	<div id="app" dir="rtl">
		<router-view />

		<!-- תפריט תחתון -->
		<footer class="footer">
			<div class="footer-links">
				<router-link to="/privacy">מדיניות פרטיות</router-link>
				<span class="copyright">© 2025 העלאת סרטוני יוטיוב לדרייב</span>
			</div>
		</footer>
	</div>
</template>

<script>
export default {
	name: 'App',
}
</script>

<style>
:root {
	--primary-color: #4285F4;
	--secondary-color: #34A853;
	--danger-color: #EA4335;
	--warning-color: #FBBC05;
	--background-color: #f7f9fc;
	--card-color: #ffffff;
	--text-color: #3c4043;
}

body {
	font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
	background-color: var(--background-color);
	margin: 0;
	padding: 20px;
	color: var(--text-color);
	padding-bottom: 60px;
	/* מרווח בתחתית עבור הפוטר */
}

#app {
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	min-height: 100vh;
	position: relative;
}

.footer {
	position: fixed;
	bottom: 0;
	left: 0;
	right: 0;
	padding: 15px 0;
	text-align: center;
	background-color: #f1f3f4;
	border-top: 1px solid #ddd;
	width: 100%;
	z-index: 100;
}

.footer-links {
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 20px;
}

.footer-links a {
	color: var(--primary-color);
	text-decoration: none;
}

.footer-links a:hover {
	text-decoration: underline;
}

.copyright {
	color: #666;
	font-size: 0.9em;
}
</style>
